import { connect } from 'react-redux';
import RuleReportDashboard from '../components/RuleReportDashboard';
import {
    loadRuleReport,
    generateRuleReport,
    ruleReportInputChange,
    initLoadRuleReportActionStatus,
    initGenerateRuleReportActionStatus,
    openResolveRuleReportModal,
    closeResolveRuleReportModal,
    resolveRuleReportChangeInput,
    updateRuleReport,
    initUpdateRuleReportActionStatus,
    selectRuleReport,
    generateStatReport,
    initStatReportActionStatus,
} from '../ruleReportActions';
import { loadRuleMaster } from '../../ruleMaster/ruleMasterActions';
import { doOperationRecordAction } from '../../../common/operationRcd/OperationRecordActions';

const mapStateToProps = state => ({
    ruleReportQueryFields: state.ruleReport.ruleReportQueryFields,
    loadRuleReportActionStatus: state.ruleReport.loadRuleReportActionStatus,
    ruleReportActionResp: state.ruleReport.ruleReportActionResp,
    generateRuleReportActionStatus: state.ruleReport.generateRuleReportActionStatus,
    generateRuleReportActionResp: state.ruleReport.generateRuleReportActionResp,
    ruleMasterActionResp: state.ruleMaster.loadRuleMasterActionResp,
    operationRecord: state.operationRecord,
    selectedRuleReportArray: state.ruleReport.selectedRuleReportArray,
    resolveModal: state.ruleReport.resolveModal,
    updateRuleReportActionStatus: state.ruleReport.updateRuleReportActionStatus,
    updateRuleReportActionResp: state.ruleReport.updateRuleReportActionResp,
    statReportActionStatus: state.ruleReport.statReportActionStatus,
    statReportActionResp: state.ruleReport.statReportActionResp,
});

const mapDispatchToProps = dispatch => ({
    loadRuleReport: (date, ruleCategory, fund) => dispatch(loadRuleReport(date, ruleCategory, fund)),
    generateRuleReport: (date, ruleCategory, fund) => dispatch(generateRuleReport(date, ruleCategory, fund)),
    ruleReportInputChange: input => dispatch(ruleReportInputChange(input)),
    selectRuleReport: selectedArray => dispatch(selectRuleReport(selectedArray)),
    initLoadRuleReportActionStatus: () => dispatch(initLoadRuleReportActionStatus()),
    initGenerateRuleReportActionStatus: () => dispatch(initGenerateRuleReportActionStatus()),
    loadRuleMaster: () => dispatch(loadRuleMaster()),
    doOperationRecordAction: params => dispatch(doOperationRecordAction(params)),
    openResolveRuleReportModal: record => dispatch(openResolveRuleReportModal(record)),
    closeResolveRuleReportModal: () => dispatch(closeResolveRuleReportModal()),
    resolveRuleReportChangeInput: input => dispatch(resolveRuleReportChangeInput(input)),
    updateRuleReport: ruleReportVO => dispatch(updateRuleReport(ruleReportVO)),
    initUpdateRuleReportActionStatus: () => dispatch(initUpdateRuleReportActionStatus()),
    generateStatReport: (fromDate, toDate) => dispatch(generateStatReport(fromDate, toDate)),
    initStatReportActionStatus: () => dispatch(initStatReportActionStatus()),
});


export default connect(mapStateToProps, mapDispatchToProps)(RuleReportDashboard);
